import { useSelector } from 'react-redux'
import { useOutletContext } from 'react-router-dom'
import { Card, CardContent, CardHeader, CardTitle } from 'components/ui/card'
import { Badge } from 'components/ui/badge'
import { isAskMdtAvailable } from 'features/AskMdt'
import { AreaNarrativePanel } from 'features/AskMdt/components/AreaNarrativePanel'
import type { SiteOutletContext } from '../Sites_ShowCN'

const Field = ({ label, value }: { label: string; value?: string | number | null }) => (
	<div>
		<div className="text-xs uppercase tracking-wide text-muted-foreground">{label}</div>
		<div className="text-sm text-foreground">{value || <span className="text-gray-400">—</span>}</div>
	</div>
)

const SiteOverview = () => {
	const { site, siteId } = useOutletContext<SiteOutletContext>()
	const askAvailable = isAskMdtAvailable(useSelector((state: any) => state.userLogin?.userInfo))

	const evaluations = Array.isArray(site.evaluations) ? site.evaluations : []

	return (
		<div className="space-y-4">
			<Card>
				<CardHeader>
					<CardTitle>Site details</CardTitle>
				</CardHeader>
				<CardContent>
					<div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
						<Field label="Name" value={site.name} />
						<Field label="Property type" value={site.propertyType} />
						<Field label="Square feet" value={site.sqft} />
						<Field label="Address" value={site.address} />
						<Field label="City" value={site.city} />
						<Field label="State" value={site.state} />
						<Field label="Postal code" value={site.postalCode} />
						<Field label="Frontage" value={site.frontage} />
						<Field label="Parking" value={site.parking} />
						<Field label="Condition" value={site.condition} />
						<Field label="Co-tenants" value={site.coTenants} />
						<Field
							label="Coordinates"
							value={
								site.latitude && site.longitude
									? `${site.latitude}, ${site.longitude}`
									: site.approxLabel
										? `Approximate — ${site.approxLabel}`
										: null
							}
						/>
					</div>
				</CardContent>
			</Card>

			{askAvailable && <AreaNarrativePanel anchorType="EvaluationSite" anchorId={siteId} />}

			<Card>
				<CardHeader>
					<CardTitle>Evaluations</CardTitle>
				</CardHeader>
				<CardContent>
					{evaluations.length === 0 ? (
						<p className="text-sm text-muted-foreground">
							This site is not linked to any evaluation yet.
						</p>
					) : (
						<div className="flex flex-wrap gap-2">
							{evaluations.map((evaluation: any) => (
								<Badge key={evaluation._id || evaluation}>
									{evaluation.name || 'Evaluation'}
								</Badge>
							))}
						</div>
					)}
				</CardContent>
			</Card>
		</div>
	)
}

export default SiteOverview
